<ng-container *ngIf="activeUser$ | async as activeUser">
  <div class="officer-information-wrapper p-4" [ngStyle]="boxStyles">
    <section class="information-container relative" *ngIf="item?.officer?.officerProfile as officerProfile">
      <p *ngIf="item.renderOfficerRole !== 'Director'; else inDirectorTitle"
         class="mat-title !text-base !mb-4  text-[#3a4856] font-secondary">Shareholder Information</p>

      <ng-template #inDirectorTitle>
        <p class="mat-title !text-base !mb-4  text-[#3a4856] font-secondary">Director Information</p>
      </ng-template>

      <p class="absolute top-0 right-0">
        <ng-container *ngIf="allowEdit && !item.isIndirect(); else indirectToggle">
          <button matTooltip="Edit Info"
                  class="bg-[#2A8BC4] rounded-md border-0 py-1 px-2 disabled:bg-[#DFDEDE] cursor-pointer disabled:cursor-not-allowed"
                  (click)="onEdit(item)" [disabled]="!activeUser.isCustomer()">
            <mat-icon [ngStyle]="{'color': 'white', 'font-size': '20px', 'width': '20px', 'height': '20px'}">
              edit
            </mat-icon>
          </button>
        </ng-container>
        <ng-template #indirectToggle>
          <button matTooltip="Edit Info"
                  class="bg-[#2A8BC4] rounded-md border-0 py-1 px-2 disabled:bg-[#DFDEDE] cursor-pointer disabled:cursor-not-allowed"
                  (click)="toggleEditShareholder()" *ngIf="allowEdit && !isVisible">
            <mat-icon [ngStyle]="{'color': 'white', 'font-size': '20px', 'width': '20px', 'height': '20px'}">
              edit
            </mat-icon>
          </button>
        </ng-template>
      </p>

      <div *ngIf="!isVisible">
        <div class="grid grid-cols-2 gap-2">
          <p *ngIf="directorOfficer && directorOfficer.dateOfCessation" class="block w-64 !mb-3">
            <span class="block mb-1 font-['OpenSans']">Date of Cessation&colon;</span>
            <span class="block m-0 font-['OpenSans_Bold'] font-bold">
              {{ directorOfficer.dateOfCessation | date: "MMM dd, yyyy" }}
            </span>
          </p>
        </div>

        <!--      Officer Individual Type -->
        <ng-container *ngIf="officerProfile.__typename === 'OfficerPersonType'">
          <div class="grid grid-cols-2 gap-2">
            <p class="block w-64 !mb-3">
              <span class="block mb-1 font-['OpenSans']">Type: </span>
              <span class="block m-0 font-['OpenSans_Bold'] font-bold">{{
                  item.officer.isIndividual
                    ? "Individual"
                    : item.officer.isCorporate
                      ? "Corporate"
                      : ""
                }}</span>
            </p>

            <p class="block w-64 !mb-3">
              <span class="block mb-1 font-['OpenSans']">Name&colon;</span>
              <span class="block m-0 font-['OpenSans_Bold'] font-bold">
                {{ item.officer.name }}
              </span>
            </p>

            <p class="block w-64 !mb-3">
              <span class="block mb-1 font-['OpenSans']">Position Held&colon;</span>
              <span class="block m-0 font-['OpenSans_Bold'] font-bold">
                {{ item.renderOfficerRole }}
              </span>
            </p>

            <ng-container *ngIf="!item.isNominee">
              <p class="block w-64 !mb-3">
                <span class="block mb-1 font-['OpenSans']">Identification Document&colon;</span>
                <span class="block m-0 font-['OpenSans_Bold'] font-bold">
                  {{
                    officerProfile.identification?.officerIdentificationType
                      ?.label
                  }}
                </span>
              </p>

              <p class="block w-64 !mb-3">
                <span class="block mb-1 font-['OpenSans']">Identification No&colon;</span>
                <span class="block m-0 font-['OpenSans_Bold'] font-bold">
                  {{ officerProfile.identification?.identificationNumber }}
                </span>
              </p>

              <p class="block w-64 !mb-3">
                <span class="block mb-1 font-['OpenSans']">Expiry Date&colon;</span>
                <span class="block m-0 font-['OpenSans_Bold'] font-bold">
                  {{
                    !officerProfile.identification?.expiryDate
                      ? "-"
                      : (officerProfile.identification?.expiryDate | date)
                  }}
                </span>
              </p>

              <p class="block w-64 !mb-3">
                <span class="block mb-1 font-['OpenSans']">Nationality&colon;</span>
                <span class="block m-0 font-['OpenSans_Bold'] font-bold">
                  {{ officerProfile.identification?.nationality?.name }}</span>
              </p>

              <p class="block w-64 !mb-3">
                <span class="block mb-1 font-['OpenSans']">Email&colon;</span>
                <span class="block m-0 font-['OpenSans_Bold'] font-bold">
                  {{ officerProfile.email }}
                </span>
              </p>

              <p class="block w-64 !mb-3">
                <span class="block mb-1 font-['OpenSans']">Phone&colon; </span>
                <span class="block m-0 font-['OpenSans_Bold'] font-bold">
                  {{ officerProfile.address?.phone ?? "-" }}
                </span>
              </p>

              <p class="block w-64 !mb-3">
                <span class="block mb-1 font-['OpenSans']">Address&colon;</span>
                <span class="block m-0 font-['OpenSans_Bold'] font-bold">
                  {{ officerProfile.address?.fullAddress ?? "-" }}
                </span>
              </p>
            </ng-container>
          </div>
        </ng-container>

        <!--      Officer Corporate Type -->
        <ng-container *ngIf="officerProfile.__typename === 'OfficerCompanyType'">
          <div class="grid grid-cols-2 gap-2">
            <p class="block w-64 !mb-3">
              <span class="block mb-1 font-['OpenSans']">Type: </span>
              <span class="block m-0 font-['OpenSans_Bold'] font-bold">{{
                  item.officer.isIndividual
                    ? "Individual"
                    : item.officer.isCorporate
                      ? "Corporate"
                      : ""
                }}</span>
            </p>

            <p class="block w-64 !mb-3">
              <span class="block mb-1 font-['OpenSans']">Corporate Name&colon;</span>
              <span class="block m-0 font-['OpenSans_Bold'] font-bold">
                {{ officerProfile.name }}
              </span>
            </p>

            <p class="block w-64 !mb-3">
              <span class="block mb-1 font-['OpenSans']">Position Held&colon;</span>
              <span class="block m-0 font-['OpenSans_Bold'] font-bold">
                {{ item.renderOfficerRole }}
              </span>
            </p>

            <p class="block w-64 !mb-3">
              <span class="block mb-1 font-['OpenSans']">Country of Incorporation&colon;</span>
              <span class="block m-0 font-['OpenSans_Bold'] font-bold">
                {{ officerProfile.country?.name ?? "-" }}
              </span>
            </p>

            <p class="block w-64 !mb-3">
              <span class="block mb-1 font-['OpenSans']">Registration Number&colon;</span>
              <span class="block m-0 font-['OpenSans_Bold'] font-bold">
                {{ officerProfile.registrationNumber }}
              </span>
            </p>

            <p class="block w-64 !mb-3">
              <span class="block mb-1 font-['OpenSans']">Email&colon;</span>
              <span class="block m-0 font-['OpenSans_Bold'] font-bold">
                {{ officerProfile.email }}
              </span>
            </p>

            <p class="block w-64 !mb-3">
              <span class="block mb-1 font-['OpenSans']">Phone&colon;</span>
              <span class="block m-0 font-['OpenSans_Bold'] font-bold">
                {{ officerProfile.address?.phone ?? "-" }}
              </span>
            </p>

            <p class="block w-64 !mb-3">
              <span class="block mb-1 font-['OpenSans']">Address&colon;</span>
              <span class="block m-0 font-['OpenSans_Bold'] font-bold">
                {{ officerProfile.address?.fullAddress ?? "-" }}
              </span>
            </p>
          </div>

          <ng-container *ngIf="item.officer.isCorporate">
            <ng-container *ngIf="
                getRepresentativeInfo(officerProfile) as representativeProfile
              ">
              <mat-divider class="!mx-auto !my-3 !col-span-2"></mat-divider>
              <p class="mat-title !text-base !mb-4 text-[#3a4856] font-secondary">Corporate Representative:</p>

              <div class="grid grid-cols-2 gap-2">
                <p class="block w-64 !mb-3">
                  <span class="block mb-1 font-['OpenSans']">Name&colon;</span>
                  <span class="block m-0 font-['OpenSans_Bold'] font-bold">
                    {{
                      representativeProfile.firstName +
                      " " +
                      representativeProfile.lastName
                    }}
                  </span>
                </p>

                <p class="block w-64 !mb-3">
                  <span class="block mb-1 font-['OpenSans']">Identification Document&colon;</span>
                  <span class="block m-0 font-['OpenSans_Bold'] font-bold">
                    {{
                      representativeProfile.identification?.officerIdentificationType?.name ??
                      "-"
                    }}
                  </span>
                </p>

                <p class="block w-64 !mb-3">
                  <span class="block mb-1 font-['OpenSans']">Identification No&colon;</span>
                  <span class="block m-0 font-['OpenSans_Bold'] font-bold">
                    {{
                      representativeProfile.identification?.identificationNumber ?? "-"
                    }}
                  </span>
                </p>

                <p class="block w-64 !mb-3">
                  <span class="block mb-1 font-['OpenSans']">Expiry Date&colon;</span>
                  <span class="block m-0 font-['OpenSans_Bold'] font-bold">
                    {{
                      (representativeProfile?.identification?.expiryDate
                        | date) ?? "-"
                    }}
                  </span>
                </p>

                <p class="block w-64 !mb-3">
                  <span class="block mb-1 font-['OpenSans']">Nationality&colon;</span>
                  <span class="block m-0 font-['OpenSans_Bold'] font-bold">
                    {{
                      representativeProfile?.identification?.nationality?.name ??
                      "-"
                    }}</span>
                </p>

                <p class="block w-64 !mb-3">
                  <span class="block mb-1 font-['OpenSans']">Email&colon;</span>
                  <span class="block m-0 font-['OpenSans_Bold'] font-bold">
                    {{ representativeProfile.email }}
                  </span>
                </p>

                <p class="block w-64 !mb-3">
                  <span class="block mb-1 font-['OpenSans']">Address&colon;</span>
                  <span class="block m-0 font-['OpenSans_Bold'] font-bold">
                    {{
                      representativeProfile.address
                        ? commonHelper.renderAddress(representativeProfile.address)
                        : "-"
                    }}
                  </span>
                </p>
              </div>
            </ng-container>
          </ng-container>
        </ng-container>

        <ng-container *ngIf="officerProfile.__typename === 'OfficerIndirectPersonType'">
          <div class="grid grid-cols-2 gap-2">
            <p class="block w-64 !mb-3">
              <span class="block mb-1 font-['OpenSans']">Type: </span>
              <span class="block m-0 font-['OpenSans_Bold'] font-bold">{{
                  item.officer.isIndividual
                    ? "Individual"
                    : item.officer.isCorporate
                      ? "Corporate"
                      : ""
                }}</span>
            </p>

            <p class="block w-64 !mb-3">
              <span class="block mb-1 font-['OpenSans']">First Name&colon;</span>
              <span class="block m-0 font-['OpenSans_SemiBold'] font-bold">
                {{ item.officer.name }}
              </span>
            </p>


            <p class="block w-64 !mb-3">
              <span class="block mb-1 font-['OpenSans']">Position Held&colon;</span>
              <span class="block m-0 font-['OpenSans_SemiBold'] font-bold">
                {{ item.renderOfficerRole }}
              </span>
            </p>

            <p class="block w-64 !mb-3">
              <span class="block mb-1 font-['OpenSans']">Residence&colon;</span>
              <span class="block m-0 font-['OpenSans_Bold'] font-bold">{{
                  officerProfile.country?.name
                }}</span>
            </p>

            <p class="block w-64 !mb-3">
              <span class="block mb-1 font-['OpenSans']">Nationality&colon;</span>
              <span class="block m-0 font-['OpenSans_Bold'] font-bold">{{
                  officerProfile.nationality?.name
                }}</span>
            </p>

            <p class="block w-64 !mb-3">
              <span class="block mb-1 font-['OpenSans']">Ownership&colon;</span>
              <span class="block m-0 font-['OpenSans_Bold'] font-bold">
                {{ percentageOfShares }}            
              </span>
            </p>
          </div>
        </ng-container>

        <ng-container *ngIf="officerProfile.__typename === 'OfficerIndirectCompanyType'">
          <div class="grid grid-cols-2 gap-2">
            <p class="block w-64 !mb-3">
              <span class="block mb-1 font-['OpenSans']">Type: </span>
              <span class="block m-0 font-['OpenSans_Bold'] font-bold">{{
                  item.officer.isIndividual
                    ? "Individual"
                    : item.officer.isCorporate
                      ? "Corporate"
                      : ""
                }}</span>
            </p>

            <p class="block w-64 !mb-3">
              <span class="block mb-1 font-['OpenSans']">Position Held&colon;</span>
              <span class="block m-0 font-['OpenSans_Bold'] font-bold">
                {{ item.renderOfficerRole }}
              </span>
            </p>

            <p class="block w-64 !mb-3">
              <span class="block mb-1 font-['OpenSans']">Corporate Name&colon;</span>
              <span class="block m-0 font-['OpenSans_Bold'] font-bold">
                {{ officerProfile.name }}
              </span>
            </p>

            <p class="block w-64 !mb-3">
              <span class="block mb-1 font-['OpenSans']">Country of Incorporation&colon;</span>
              <span class="block m-0 font-['OpenSans_Bold'] font-bold">
                {{ officerProfile.country?.name ?? "-" }}
              </span>
            </p>

            <p class="block w-64 !mb-3">
              <span class="block mb-1 font-['OpenSans']">Registration Number&colon;</span>
              <span class="block m-0 font-['OpenSans_Bold'] font-bold">
                {{ officerProfile.registrationNumber }}
              </span>
            </p>

            <p class="block w-64 !mb-3">
              <span class="block mb-1 font-['OpenSans']">Ownership&colon;</span>
              <span class="block m-0 font-['OpenSans_Bold'] font-bold">
                {{ percentageOfShares }}            
              </span>
            </p>
          </div>
        </ng-container>
      </div>

      <!-- Edit Officer Infomation -->
      <ng-container *ngIf="isVisible">
        <ng-container *ngIf="item.officer.officerType === officerType.Corporate">
          <form *ngIf="companyIndirectCompanyShareholderForm as corporateForm" [formGroup]="corporateForm"
                class="flex flex-col relative">
            <div class="grid grid-cols-2 gap-4 w-3/5">
              <mat-form-field appearance="outline">
                <mat-label>Type</mat-label>
                <input matInput [value]="item.officer.officerType" disabled class="capitalize">
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Name</mat-label>
                <input type="text" matInput [formControl]="corporateForm.controls.officerProfile.controls.name"
                       placeholder="Name">
                <mat-error *ngIf="corporateForm.controls.percentageOfShares.hasError('required')">
                  Name is <strong>required</strong>
                </mat-error>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Incorporation Country</mat-label>
                <app-country-select-input required
                                          [formControl]="corporateForm.controls.officerProfile.controls.countryId"></app-country-select-input>
                <mat-error *ngIf="corporateForm.controls.officerProfile.controls.countryId.hasError('required')">
                  Country is required
                </mat-error>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Registration number</mat-label>
                <input type="text" matInput
                       [formControl]="corporateForm.controls.officerProfile.controls.registrationNumber"
                       placeholder="Registration number">
                <mat-error
                  *ngIf="corporateForm.controls.officerProfile.controls.registrationNumber.hasError('required')">
                  Registration number is required
                </mat-error>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Incorporation Date</mat-label>
                <input matInput placeholder="Incorporation Date" [max]="today" [matDatepicker]="IncorporationDate"
                       [formControl]="corporateForm.controls.officerProfile.controls.registrationDate"/>
                <mat-datepicker-toggle matSuffix [for]="IncorporationDate"></mat-datepicker-toggle>
                <mat-datepicker #IncorporationDate></mat-datepicker>
              </mat-form-field>

              <ng-template *ngTemplateOutlet="baseControl"></ng-template>
            </div>

            <div class="flex gap-2 absolute right-0 top-0 -mt-10">
              <button mat-raised-button class="bg-grey-800 text-white cursor-pointer" (click)="toggleEditShareholder()">
                Cancel
              </button>

              <button mat-raised-button color="primary" class="w-48 cursor-pointer" appConfirmDialog (ok)="submitForm()">
                Save change
              </button>
            </div>
          </form>
        </ng-container>

        <ng-container *ngIf="item.officer.officerType === officerType.Individual">
          <form *ngIf="companyIndirectIndividualShareholderForm as individualForm" [formGroup]="individualForm"
                class="flex flex-col relative">
            <div class="grid grid-cols-2 gap-4 w-3/5">
              <mat-form-field appearance="outline">
                <mat-label>Type</mat-label>
                <input matInput [value]="item.officer.officerType" disabled class="capitalize">
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>First name</mat-label>
                <input type="text" matInput [formControl]="individualForm.controls.officerProfile.controls.firstName"
                       placeholder="First name">
                <mat-error *ngIf="individualForm.controls.percentageOfShares.hasError('required')">
                  First name is <strong>required</strong>
                </mat-error>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Last name</mat-label>
                <input type="text" matInput [formControl]="individualForm.controls.officerProfile.controls.lastName"
                       placeholder="Last name">
                <mat-error *ngIf="individualForm.controls.percentageOfShares.hasError('required')">
                  Last name is <strong>required</strong>
                </mat-error>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Nationality</mat-label>
                <app-country-select-input required
                                          [formControl]="individualForm.controls.officerProfile.controls.nationalityId"></app-country-select-input>
                <mat-error *ngIf="individualForm.controls.officerProfile.controls.nationalityId.hasError('required')">
                  Nationality is required
                </mat-error>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Residence</mat-label>
                <app-country-select-input required
                                          [formControl]="individualForm.controls.officerProfile.controls.countryId"></app-country-select-input>
                <mat-error *ngIf="individualForm.controls.officerProfile.controls.countryId.hasError('required')">
                  Residence is required
                </mat-error>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Identification Document</mat-label>
                <mat-select [value]=""
                            [formControl]="individualForm.controls.officerProfile.controls.identificationTypeId"
                            class="capitalize">
                  <mat-option *ngFor="let item of identificationType" [value]="item.id" class="capitalize">{{
                      item.name
                    }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Identification Number</mat-label>
                <input type="text" matInput
                       [formControl]="individualForm.controls.officerProfile.controls.identificationNumber"
                       placeholder="Registration number">
                <mat-error
                  *ngIf="individualForm.controls.officerProfile.controls.identificationNumber.hasError('required')">
                  Identification number is required
                </mat-error>
              </mat-form-field>

              <ng-template *ngTemplateOutlet="baseControl"></ng-template>
            </div>

            <div class="flex gap-2 absolute right-0 top-0 -mt-10">
              <button mat-raised-button class="bg-grey-800 text-white cursor-pointer" (click)="toggleEditShareholder()">
                Cancel
              </button>

              <button mat-raised-button color="primary" class="w-48 cursor-pointer" appConfirmDialog (ok)="submitForm()">
                Save change
              </button>
            </div>
          </form>
        </ng-container>

        <ng-template #baseControl>
          <mat-form-field appearance="outline">
            <mat-label>Percentage of shares</mat-label>
            <app-percent-input [formControl]="form.controls.percentageOfShares"
                               placeholder="Percentage of shares"></app-percent-input>
            <mat-error *ngIf="form.controls.percentageOfShares.hasError('required')">
              Percentage of shares is <strong>required</strong>
            </mat-error>
            <mat-error *ngIf="form.controls.percentageOfShares.hasError('biggerThan')">
              Percentage of shares should be bigger than
              to {{ form.controls.percentageOfShares.errors.biggerThan.number | percent:'.0-6' }}
            </mat-error>
            <mat-error *ngIf="form.controls.percentageOfShares.hasError('max')">
              Percentage of shares should be less than or equal
              to {{ form.controls.percentageOfShares.errors.max.max | percent:'.0-6' }}
            </mat-error>
            <mat-icon matSuffix class="text-lightGray">percentage</mat-icon>
          </mat-form-field>
        </ng-template>
      </ng-container>
    </section>
  </div>
</ng-container>
